import { CustomModule } from './custom-module.model';
import { ChannelSettings } from './channel-settings.model';
import { Partner } from './partner.model';
import { Link } from './link.model';
import { Language } from './language.model';
import { SocialNetworkLink } from './movie-entities';
import { Image } from './image-entities';
import { Video } from './video-entities/video.model';
import { UserRole } from './user-role.enum';
import { CustomPage } from './custom-page.model';
export class Channel {
  id?: number;
  uuid?: string;
  copyrightText?: string;
  name?: string;
  domain?: string;
  homePage?: string;
  senderEmail?: string;
  logo?: string;
  logoSmall?: string;
  updatedTC?: number;
  defaultLocation?: string;
  partner?: Partner;
  created?: number;
  active?: boolean;
  released?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  facebookPixel?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mailchimpSettings?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  googleTag?: any;
  googleAdSense: string;
  googleAnalytics4?: string;
  googleAds?: string;
  snapchat?: string;
  twitter?: string;
  radius: number;
  languages: Language[];
  commsConsumerEticket: boolean;
  commsConsumerReminder: boolean;
  commsConsumerReview: boolean;
  commsCinemaSales: boolean;
  commsConsumerSignup: boolean;
  commsConsumerDemandit: boolean;
  commsConsumerCinemaMarketing: boolean;
  commsConsumerPartnerMarketing: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metaTitle?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metaDescription?: any;
  radiusKm: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mailchimpDomain?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mailchimpAccount?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mailchimpList?: any;
  hubspot?: string;
  logoUrl: string;
  logoSmallUrl: string;
  /**
   * Use {@link logoUrl} instead
   */
  faviconUrl: string;
  slideUrl: string;
  socialNetworks: SocialNetworkLink[];
  channelSlides: Image[];
  channelVideos: Video[];
  settings?: ChannelSettings;
  links?: Link[];
  headerLinks?: Link[];
  footerLinks?: Link[];
  customPages: CustomPage[];
  _customModules: CustomModule[];
  get customModules(): CustomModule[] {
    return this._customModules;
  }
  set customModules(modules: CustomModule[]) {
    modules = modules.map(module => {
      /**
       * Retribe if in the module title exists the language code
       * title:lang[es] or title:lang[en]
       */
      const title = module.title;
      const langRegex = /:lang\[(.*?)\]/g;
      const langMatch = langRegex.exec(title);
      if (langMatch) {
        const lang = langMatch[1];
        module.language = lang;
        module.title = title.replace(langRegex, '');
      }
      return module;
    });
    this._customModules = modules;
  }

  tilePhoto?: string;
  tilePhotoUrl?: string;
  portraitPhoto?: string;
  portraitPhotoUrl?: string;
  userRoles?: UserRole[];
  /**
   * @deprecated
   */
  googleAnalytics?: string;

  getCustomModule(identifier: number | string, params?: { language?: string; startWith?: string }): CustomModule {
    const { language, startWith } = params || {};
    let modules = this.customModules;
    let modulesLanguage = [];

    // Filter by language
    if (language) {
      modulesLanguage = modules.filter(module => module.language === language);
      modules = modules.filter(module => !module.language);
    }
    if (!params || (language && !startWith)) {
      if (typeof identifier == 'number' && !isNaN(parseInt(`${identifier}`))) {
        if (language) {
          const moduleById = [...modulesLanguage, ...modules].find(module => module.id === identifier);
          const res = modulesLanguage.find(module => module?.title === moduleById?.title) || null;
          if (!res) return moduleById;
          return res;
        } else {
          return modules.find(module => module.id === identifier);
        }
      } else {
        let res = modulesLanguage.find(module => module.title === identifier);
        if (!res) res = modules.find(module => module.title === identifier);
        return res;
      }
    } else {
      if (startWith) {
        let res = modulesLanguage.find(module => module.title.startsWith(startWith));
        if (!res) res = modules.find(module => module.title.startsWith(startWith));
        return res;
      }
    }
    return null;
  }

  getCustomModules(params?: { language?: string; startWith?: string }): CustomModule[] {
    const { language, startWith } = params || {};
    let modules = this.customModules;
    let modulesLanguage = [];
    // Filter by language
    if (language) {
      modulesLanguage = modules.filter(module => module.language === language);
      modules = modules.filter(module => !module.language);
    }
    if (!params) {
      return modulesLanguage.length > 0 ? modulesLanguage : modules;
    } else {
      if (startWith) {
        let res = modulesLanguage.filter(module => module.title.startsWith(startWith));
        if (res.length === 0) res = modules.filter(module => module.title.startsWith(startWith));
        return res;
      }
    }
    return null;
  }

  getCustomPage(urlMapping: string): CustomPage {
    urlMapping = urlMapping?.split('?')[0]; // Remove url params
    const customPage = this.customPages.find(o => o.urlMapping === urlMapping);
    return customPage;
  }
}
